import React from 'react';
import { useNavigate } from 'react-router-dom';

export const GAMES = [
  {
    id: 'timer5',
    emoji: '⏱️',
    title: '3.0000000秒ぴったりストップウォッチ',
    description: 'スタートを押してちょうど3秒でストップ！\n0.7秒以降はタイマーが消えるよ。',
    path: '/games/timer3',
  },
  {
    id: 'balldodge',
    emoji: '🐱',
    title: 'ビームねこ',
    description: 'ヘビをビームで倒せ！\nどんどん敵が増えてくるぞ。',
    path: '/games/beam-neko',
  },
  {
    id: 'stock-market',
    emoji: '📈',
    title: '株式売買ゲーム',
    description: '毎時00分〜54分が取引時間！株を売り買いして損益を競え。',
    path: '/games/stock-market',
  },
];

const ARCHIVED = [
  {
    id: 'study-meet',
    emoji: '📚',
    title: 'StudyMeet',
    description: '開発中。YouTubeコメントで参加できる学習配信アプリを再設計中。',
    path: '/study-meet',
    adminOnly: true,
  },
  {
    id: 'study',
    emoji: '🎓',
    title: '学習管理',
    description: '科目別の学習スケジュール管理。\n今日のタスク・7日間・1ヶ月の目標を記録。',
    path: '/study',
    adminOnly: true,
  },
];

const TOOLS = [
  {
    id: 'pomodoro',
    emoji: '🍅',
    title: 'ポモドーロタイマー',
    description: '集中時間と休憩時間を繰り返して\n作業効率を上げよう。',
    path: '/tools/pomodoro',
  },
];

export default function GamesView({ ctx, category }) {
  const navigate = useNavigate();
  const { isAdmin, isSemiAdmin, setTab } = ctx;

  const CATEGORY_META = {
    tools:    { label: '🛠️ ツール',    items: TOOLS,                                                      renderItem: (item) => navigate(item.path) },
    games:    { label: '🎮 ゲーム',    items: GAMES.filter(g => !g.adminOnly || isAdmin),                 renderItem: (item) => navigate(item.path) },
    archived: { label: '🗑️ 没アプリ', items: ARCHIVED.filter(g => !g.adminOnly || isAdmin),              renderItem: (item) => item.tabSwitch ? setTab(item.tabSwitch) : navigate(item.path) },
  };

  const { label, items, renderItem } = CATEGORY_META[category] || CATEGORY_META.games;

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: '20px 16px 80px' }}>
      <h1 style={{ fontSize: 20, fontWeight: 800, color: '#1a1a2e', margin: '0 0 20px', display: 'flex', alignItems: 'center', gap: 8 }}>
        {label}
      </h1>
      <div className="games-grid">
        {items.map(item => (
          <div
            key={item.id}
            className="game-card"
            onClick={() => renderItem(item)}
            style={{ cursor: 'pointer' }}
          >
            <div className="game-card-content">
              <div style={{ fontSize: 48, marginBottom: 10 }}>{item.emoji}</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#1f2937', marginBottom: 6 }}>{item.title}</div>
              <div style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'pre-line', lineHeight: 1.6 }}>{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
